import i from "./index.ce.vue.js";
import { defineAndRegisterElement as o } from "../../utils/register-element.js";
const t = o(i);
export {
  t as initUploadFileDialog
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/upload-file-dialog/index.js
// module id = 1334
// module chunks = 67